<script>
  import HelperText from "@smui/textfield/helper-text/index";

  export let label = "";
  export let value = "";
  export let helperText = "";
</script>

<style>
  .value {
    padding-top: 20px;
    padding-bottom: 6px;
    line-height: 1.75rem;
    width: 100%;
    min-width: 200px;
  }
</style>

<label class="mdc-text-field smui-text-field--standard mdc-ripple-upgraded">
  <span class="value"> <slot>{value} </slot> </span>
  <span class="mdc-floating-label mdc-floating-label--float-above">
    {label}
  </span>
  <div class="mdc-line-ripple" />
</label>
<HelperText>{helperText}</HelperText>
